import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { systemFeatures } from '../../data/systemFeatures';
export function SystemSteps() {
  return <section className="bg-paper py-10 sm:py-14" data-id="element-158" data-mp="2rag9zrqkzve4">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-159" data-mp="2rbrghzbevh8x">
        <SectionTag icon="🎯" tone="primary" data-id="element-160" data-mp="2w8hv0i7ki4s8">
          Sistema "Abre y da clase"
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-161" data-mp="3jzwxqc39ao40">
          Todo está listo. Solo abrí y enseñá.
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-4" data-id="element-162" data-mp="3a9amsv6hilrn">
        {systemFeatures.map((feature, i) => <m.div key={feature.label} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.06
      }} className="flex flex-col items-center gap-3 rounded-2xl border border-primary/10 bg-white p-5 text-center shadow-card-light" data-id="element-163" data-mp="3f6knj6zbqjus" data-mpi={i}>
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-accent/10" data-id="element-164" data-mp="mieh10yh3qn7">
              <feature.icon size={20} className="text-accent" data-id="element-165" data-mp="1099vqtvnl1yp" />
            </div>
            <p className="text-sm font-medium leading-snug text-ink" data-id="element-166" data-mp="vhjjujh2i656">{feature.label}</p>
          </m.div>)}
      </div>
    </section>;
}